<app-admin-header [header]="showingSelectUser ? assignUserHeader : header" [links]="showingSelectUser ? [] : (survey.accessType === 'POPUP' ? popUpLinks : links)"
  [breadcrumbs]="showingSelectUser ? assignUserBreadcrumbs : (survey.accessType==='POPUP'? PopUpbreadcrumbs : breadcrumbs)" [stats]="stats" [queryParams]="queryParams"
  (backClicked)="saveProgress()"></app-admin-header>
<app-assign-users [selectionData]="survey.attendees" (selectedUsersList)="addAttendees($event)" [userFetchUrl]="'user'"
  *ngIf="showingSelectUser"></app-assign-users>
<p-toast />
<p-messages [(value)]="messages" [enableService]="false"></p-messages>
<div *ngIf="autoQuestionAdded > 0" class="alert alert-success">
  <i class="pi pi-check success-icon"></i>
  {{ "تم إضافة " + autoQuestionAdded + " أسئلة بنجاح" }}
</div>

<div *ngIf="autoQuestionAdded == 0" class="alert alert-danger">
  <i class="pi pi-times-circle error-icon"></i>
  {{ 'No Question Added based on applied filters' | translator }}
</div>

<div *ngIf="correctError" class="alert alert-danger">
  <i class="pi pi-times-circle error-icon"></i>
  {{ "Please Select Correct Answers of Following Questions" | translator }}
</div>

<div *ngIf="labelError" class="alert alert-danger">
  <i class="pi pi-times-circle error-icon"></i>
  {{
  "Please Add Question Text & Option Label of Following Questions"
  | translator
  }}
</div>
<div *ngIf="totalError" class="alert alert-danger">
  <i class="pi pi-times-circle error-icon"></i>
  {{ "Sum of Questions Marks are not Equal to Total Marks" | translator }}
</div>
<app-skelitions [hidden]="!skelition" [value]="2" class="mb-2"></app-skelitions>
<div class="container-fluid v4-bg-img" *ngIf="!showingSelectUser && !skelition">
  <!-- side bar code start -->
  <p-sidebar class="v4-sidebar" [(visible)]="sidebarVisible">
    <div class="container-fluid p-0">
      <p-tabView class="ui-tabview v4-dsbrd-btns" [activeIndex]="0">
        <p-tabPanel class="v4-dsbrd-btns ui-tabview" header="{{ 'Questions' | translator }}">
          <div class="row">
            <div class="col-md-6 col-12 p-0 my-3" *ngFor="let category of questionBank">
              <ng-container *ngIf="category.category != 'Impact Measurement'">  
                <label class="items-label">{{
                  category.category | translator
                  }}</label>
                <div class="px-2" *ngFor="let question of category.questions">
                  <ng-container *ngIf="
                      isSurvey || !questionsHideAssessment.includes(question.type)
                    ">
                    <label (click)="addQuestion(question, true, false)" class="items">
                      <i aria-hidden="true" style="font-size: 1.2rem" class="{{ getIconClass(question.icon) }} mx-2">
                      </i>{{ question.name | translator }}</label>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="{{ 'Topics' | translator }}" *ngIf="isAssessment">
          <div class="d-flex justify-content-center">
            <h5 class="heading textt-900 mt-2 tab" [class.active]="QBTab === 'Service'"
              (click)="ChangeQBTab('Service', $event)">
              {{ "Service" | translator }}
            </h5>
            <h5 class="heading textt-900 mx-2 mt-2 tab" [class.active]="QBTab === 'Topic'"
              (click)="ChangeQBTab('Topic', $event)">
              {{ "Topic" | translator }}
            </h5>
          </div>
          <div *ngIf="QBTab == 'Service'">
            <div class="d-flex justify-content-start align-items-baseline gap-2">
              <div class="d-flex flex-column gap-2 pppp-drop">
                <p-dropdown [options]="ministries" [(ngModel)]="dropMinistry" optionLabel="label" appendTo="body"
                  (onChange)="onChangeDropdown()" [placeholder]="'Select Ministry' | translator"></p-dropdown>
                <p-dropdown [options]="types" [(ngModel)]="dropType" optionLabel="label" appendTo="body"
                  (onChange)="onChangeDropdown()" [placeholder]="'Select Type' | translator"></p-dropdown>
              </div>
              <button class="v4-btn-every m-2 py-2" (click)="resetFilters()">
                <i class="pi pi-refresh"></i>
              </button>
            </div>
            <div *ngIf="filteredQBService && filteredQBService.length <= 0" class="mt-2">
              <app-no-data></app-no-data>
            </div>
            <div class="row w-100" *ngIf="filteredQBService && filteredQBService.length > 0">
              <div *ngFor="let topic of filteredQBService">
                <div class="data-capsoules" (click)="
                    topic.questions == undefined
                      ? null
                      : addTopicQuestion(topic.questions)
                  ">
                  <div class="d-flex flex-column gap-2 w-100">
                    <div class="minisbutton d-flex justify-content-between gap-2">
                      <div class="d-flex gap-2" *ngIf="topic?.data[0]?.ministry?.label">
                        <img src="{{
                            staticFileUrl + topic?.data[0]?.ministry?.icon
                          }}" class="ministry-logo" />
                        <h5 class="miniheading">
                          {{ topic?.data[0]?.ministry?.label }}
                        </h5>
                      </div>
                      <div class="cap-nums mx-2">
                        {{
                        topic.questions == undefined
                        ? 0
                        : topic.questions.length
                        }}
                      </div>
                    </div>
                    <div class="cap-text">{{ topic.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="QBTab == 'Topic'">
            <div class="d-flex justify-content-start align-items-baseline gap-2">
              <div class="d-flex flex-column gap-2 pppp-drop">
                <p-dropdown [options]="topics" [(ngModel)]="dropTopic" optionLabel="name" appendTo="body"
                  (onChange)="onChangeDropdown()" [placeholder]="'Select Topic' | translator"></p-dropdown>
                <p-dropdown [options]="types" [(ngModel)]="dropType" optionLabel="label" appendTo="body"
                  (onChange)="onChangeDropdown()" [placeholder]="'Select Type' | translator"></p-dropdown>
              </div>
              <button class="v4-btn-every m-2 py-2" (click)="resetFilters()">
                <i class="pi pi-refresh"></i>
              </button>
            </div>
            <div *ngIf="filteredQBTopics && filteredQBTopics.length <= 0" class="mt-2">
              <app-no-data></app-no-data>
            </div>
            <div class="row w-100" *ngIf="filteredQBTopics && filteredQBTopics.length > 0">
              <div *ngFor="let topic of filteredQBTopics">
                <div class="data-capsoules" (click)="
                    topic.questions == undefined
                      ? null
                      : addTopicQuestion(topic.questions)
                  ">
                  <div class="d-flex flex-column gap-2 w-100">
                    <div class="minisbutton d-flex justify-content-between gap-2">
                      <div class="d-flex gap-2" *ngIf="topic?.questionBankTopic[0]?.name">
                        <h5 class="miniheading">
                          {{ topic?.questionBankTopic[0]?.name }}
                        </h5>
                      </div>
                      <div class="cap-nums mx-2">
                        {{
                        topic.questions == undefined
                        ? 0
                        : topic.questions.length
                        }}
                      </div>
                    </div>
                    <div class="cap-text">{{ topic.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </p-sidebar>
  <!-- side bar code end -->
  <div class="d-flex justify-content-start" *ngIf="!skelition">
    <div class="width-100 d-flex justify-content-center my-5">
      <div class="card q-pro-card">
        <div class="d-flex justify-content-center w-100 gap-2 flex-wrap">
          <button  class="btn add-logo" (click)="openReorderableModal()">
            {{ "Rearrangement" | translator }}
          </button>
          <button class="btn add-logo" *ngIf="!isTopic" (click)="openSettingsModal = true">
            {{ "Settings" | translator }}
          </button>
          <button [hidden]="survey.accessType=='POPUP'" class="btn add-logo" *ngIf="!isTopic" (click)="openAddExternalModal = true">
            {{ "Add external users" | translator }}
          </button>
          <!-- && survey.questionBankId != this.standardQBID -->
          <button class="btn add-logo" *ngIf="isTopic && survey.type == 'Service'"
            (click)="showSelectServiceModal = true">
            {{ "Select service" | translator }}
          </button>
          <button class="btn add-logo" *ngIf="!isTopic" (click)="pickImage()">
            {{ "Add a logo" | translator }}
          </button>
          <button *ngIf="survey.accessType == 'BY_ACCOUNT' && !isTopic" class="btn add-logo"
            (click)="showingSelectUser = true">
            {{ "Add participants" | translator }}
          </button>
          <button *ngIf="
              survey?.type?.requiredAttendance && !isAssessment && !isTopic
            " (click)="gotoUrl('/survey/attendance', survey._id, false)" class="btn add-logo">
            {{ "Attendance" | translator }}
          </button>
          <button *ngIf="isAssessment || isSurvey" (click)="
              gotoUrl(
                (isAssessment ? '/assessment/results/' : '/survey/results/') +
                  survey._id,
                '',
                true
              )
            " class="btn add-logo">
            {{ "Results" | translator }}
          </button>
          <button [hidden]="survey.accessType=='POPUP'" *ngIf="isAssessment || isSurvey" (click)="copyURL('/sa/' + from + '/attempt/' + survey._id)"
            class="btn add-logo">
            {{ "Copy Link" | translator }}
          </button>
          <button [hidden]="survey.accessType=='POPUP'" *ngIf="isAssessment" (click)="showAutoQuestionModal = true" class="btn add-logo">
            {{ "Auto Question" | translator }}
          </button>
          <button [hidden]="survey.accessType=='POPUP'" class="btn add-logo" target="_blank" *ngIf="!isTopic"
            (click)="gotoUrl('/sa/' + from + '/attempt/' + survey._id, '', true)">
            {{ "an offer" | translator }}
          </button>
          <button [hidden]="survey.accessType=='POPUP'" *ngIf="(startDate.getTime() != todayDate.getTime() && startDate.getTime() != tomorrow.getTime()) && (isAssessment || isSurvey)" class="btn add-logo" 
            (click)="showReminderModal = true">
            {{ "Set Reminder" | translator }}
          </button>
        </div>
        <div *ngIf="!isTopic" class="d-flex justify-content-center">
          <img *ngIf="survey.headerImage" style="max-width: 30%" class="logo-img" src="{{
              survey.headerImage ? staticFileUrl + survey.headerImage : ''
            }}" />
          <img *ngIf="!survey.headerImage" class="logo-img align-self-center"
            src="../../../../../../assets/rectangle_32.png" />
        </div>
        <div class="d-flex justify-content-start mx-5">
          <input style="
              background-color: transparent;
              font-size: 20px;
              border: none;
              border-bottom: solid 1px lightgrey;
              border-radius: 0px;
              width: 100%;
              color: white;
            " class="purple" placeholder="Name" [(ngModel)]="survey.name" type="text" pInputText />
          <input *ngIf="tags != undefined && isAssessment" style="
           background-color: transparent;
           font-size: 20px;
           border: none;
           border-bottom: solid 1px lightgrey;
           border-radius: 0px;
           width: 50%;
           color: white;
          " class="purple" [value]="tags[0].arabic" type="text" [readonly]="true" />
         <input *ngIf="tags != undefined && isSurvey" style="
           background-color: transparent;
           font-size: 20px;
           border: none;
           border-bottom: solid 1px lightgrey;
           border-radius: 0px;
           width: 50%;
           color: white;" class="purple" [value]="tags.name" type="text" [readonly]="true" />
        </div>
        <div class="d-flex justify-content-start mx-5 mt-2" *ngIf="isTopic">
          <p-editor [(ngModel)]="survey.description" class="w-100" [style]="{ height: '320px' }"></p-editor>
        </div>
        <div class="d-flex justify-content-start mx-5 mt-2" *ngIf="isTopic && survey.service && survey.service !== ''">
          <p-button (onClick)="launchUrl(survey.service)" styleC="qbl-btn" label="{{ 'Service' | translator }}"
            icon="pi pi-external-link"></p-button>
        </div>
        <div class="d-flex gap-4 align-items-start justify-content-start" *ngIf="isAssessment"
          style="margin-right: 50px; margin-top: 20px">
            <div class="d-flex column">
              <span class="ans-color mb-2">{{ "Total Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field purple"
                placeholder="{{ 'Total Marks' | translator }}" [inputStyle]="{
                  'background-color': 'transparent',
                  border: 'none',
                  'border-bottom': 'solid 1px lightgrey',
                  'border-radius': '0px',
                  width: '100%',
                  color: 'white'
                }" [(ngModel)]="survey.totalMarks" />
            </div>
            <div  class="d-flex column" *ngIf="false">
              <span class="ans-color mb-2">{{ "Default Score" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field purple"
                placeholder="{{ 'Default Score' | translator }}" [inputStyle]="{
                  'background-color': 'transparent',
                  border: 'none',
                  'border-bottom': 'solid 1px lightgrey',
                  'border-radius': '0px',
                  width: '100%',
                  color: 'white'
                }" [(ngModel)]="survey.defaultScore" />
            </div>
            <div *ngIf="survey.accessType!='POPUP'" class="d-flex column">
              <span class="ans-color mb-2">{{ "Attempt Time (mintues)" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field purple"
                placeholder="{{ 'Attempt Time (mintues)' | translator }}" [inputStyle]="{
                  'background-color': 'transparent',
                  border: 'none',
                  'border-bottom': 'solid 1px lightgrey',
                  'border-radius': '0px',
                  width: '100%',
                  color: 'white'
                }" [(ngModel)]="survey.attemptTime" />
            </div>
            <div *ngIf="survey.accessType!='POPUP'" class="d-flex column">
              <span class="ans-color mb-2">{{ "Total Participant" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field purple"
                placeholder="{{ 'Total Participant' | translator }}" [inputStyle]="{
                  'background-color': 'transparent',
                  border: 'none',
                  'border-bottom': 'solid 1px lightgrey',
                  'border-radius': '0px',
                  width: '100%',
                  color: 'white'
                }" [(ngModel)]="survey.totalParticipant" />
            </div>
        </div>
        <hr class="v4-color-white" />
        <div class="d-flex justify-content-center mb-3" *ngIf="
            isTopic ||
            isSurvey ||
            (isAssessment && getSumOfQuestionMarks() < survey.totalMarks)
          ">
          <button class="btn add-question mob-view" (click)="isImpactSurvey == true ? addQuestion(impactQuestion,true, false) : openSidebar(-1)">
            {{ "Add a question" | translator }}
          </button>
        </div>
        <!-- Second i should be replaced with editingIndex after implementing recognizing mechonizam -->
        <div *ngFor="let question of survey.questions; let i = index">
          <div>
            <app-questions-edit (click)="setCurrentEditQuestion(i)" [disabled]="canConditional(question) || canLinked(question)"
              [editingIndex]="editingIndex" [conditionalQuestions]="conditionalQuestions" 
              [linkedQuestions]="linkedQuestions" [question]="question" [disableLinkedOptions]="disableLinkedOptions"
              [questionIndex]="i" [removeQuestion]="removeQuestion"
              [disableConditionalOptions]="disableConditionalOptions" [getConditionalOptions]="getConditionalOptions"
              [isAssessment]="isAssessment" [isTopic]="isTopic" [survey]="survey" [fromTraining]="fromTraining"
              (saveProgress)="saveProgress()" [isConditional]="canConditional(question)" [isLinked]="canLinked(question)"
              [isImpactSurvey]="isImpactSurvey" [UserExternalFields]="false" ></app-questions-edit>
            <!-- position under bar with buttons custom code start -->
            <div class="pos-rel">
              <div *ngIf="false" class="pos-abs">
                <button (click)="changeSeparator(question, i)" class="btn page-break-btn {{
                    question.separator ? 'bg-primary text-light' : ''
                  }}">
                  {{ "separator" | translator }}
                  <i class="pi pi-check-square font-11"></i>
                </button>
                <button (click)="changePageBreak(question, i)" class="btn page-break-btn mx-2 {{
                    question.pageBreak ? 'bg-primary text-light' : ''
                  }}">
                  {{ "break" | translator }} {{ "the page" | translator }}
                  <i class="fa fa-chain-broken"></i>
                </button>
              </div>
              <div class="flex-center my-3 gap-2">
                <button  *ngIf="isTopic || isSurvey || (isAssessment && getSumOfQuestionMarks() < survey.totalMarks)" class="btn add-question" (click)="isImpactSurvey == true ? addQuestion(impactQuestion,true, false) : openSidebar(i)">
                  {{ "Add a question" | translator }}
                </button>
                <button class="btn add-logo" target="_blank" *ngIf="!isTopic"
                  (click)="gotoUrl('/sa/' + from + '/attempt/' + survey._id, '', true)">
                  {{ "an offer" | translator }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- footer -->
        <div *ngIf="!isTopic && survey.footerText" class="flex-start py-2 px-2 w-100">
          <p class="v4-color-white" [innerHTML]="survey.footerText | safeHTML"></p>
        </div>
        <div *ngIf="!isTopic" class="d-flex justify-content-center w-100 py-4 top-dashed" style="align-self: center">
          <button class="btn page-break-btn" (click)="openTextModal(false)">
            {{ "Thank you the text of the page" | translator }}
          </button>
          <button class="btn page-break-btn mx-2" (click)="openTextModal(true)">
            {{ "Edit footer" | translator }}
          </button>
        </div>
        <div class="w-100 d-flex justify-content-center">
          <button (click)="saveProgress()" class="btn hifz-btn">
            {{ "save" | translator }}
          </button>
        </div>
        <!-- footer end -->
      </div>
    </div>
  </div>
</div>

<!-- Footer and Thankyou page modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openModal"
  [style]="{ width: '95vw', maxWidth: '1700px' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">
      {{
      footerModal
      ? ("Update footer" | translator)
      : ("Update the thank you page text" | translator)
      }}
    </span>
  </ng-template>
  <p-editor #editor [(ngModel)]="editorText" (onTextChange)="setText($event)" [style]="{ height: '320px' }"></p-editor>
  <ng-template pTemplate="footer">
    <p-button (onClick)="closeModal()" [label]="'OK' | translator" icon="pi pi-check"></p-button>
  </ng-template>
</p-dialog>

<!-- Add externals modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openAddExternalModal"
  [style]="{ width: '95vw', maxWidth: '1200px' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{
      "Add external users" | translator
      }}</span>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="p-fluid w-100">
      <label class="mb-1" for="externals">{{
        "Add emails survey" | translator
        }}</label>
      <p-chips 
          [(ngModel)]="survey.externals" 
          [addOnBlur]="true" 
          [addOnTab]="true" 
          name="externals"
          #externalMailChips
          class="p-chipp" 
          (paste)="handlePaste($event)">
      </p-chips>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button (onClick)="openAddExternalModal = false" label="{{ 'Finished' | translator }}"
      icon="pi pi-check"></p-button>
  </ng-template>
</p-dialog>

<!-- Setings Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openSettingsModal"
  [style]="{ width: '95vw', maxWidth: '1000px' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "Survey Settings" | translator }}</span>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="d-flex gap-2 mb-4">
      <button *ngIf="isAssessment" (click)="openGradesModal = true;" class="btn add-logo-w">
        {{ "Grades" | translator }}
      </button>
      <button *ngIf="isAssessment" (click)="openCertificateTextModal = true;" class="btn add-logo-w">
        {{ "Certificate Text" | translator }}
      </button>
      <button *ngIf="isAssessment" (click)="gotoUrl('/assessment/certificate/' + survey._id + '/' + email, '', true)"
        class="btn add-logo-w">
        {{ "View Certificate" | translator }}
      </button>
      <button (click)="openExternalFieldsModal = true"
        class="btn add-logo-w">
        {{ "External User Fields" | translator }}
      </button>
    </div>
    <div class="d-flex column gap-1 align-items-start justify-content-start"
        *ngIf="isAssessment"
        class=""
        >
          <div
            class="d-flex align-items-center gap-1"
            style="margin-top: 1.5rem"
          >
            <p-checkbox
              class="v4-color-white"
              name="showCert"
              inputId="showCert"
              [binary]="true"
              [(ngModel)]="survey.showCert"
            ></p-checkbox>
            <label class="v4-color-white" for="showCert">{{
              "Show Option to View Certificate on Profile Page" | translator
            }}</label>
          </div>
        </div>
        <div class="d-flex column gap-1 align-items-start justify-content-start" style="margin-bottom: 15px;"
        *ngIf="isAssessment"
        class=""
        >
          <div
            class="d-flex align-items-center gap-1"
            style="margin-top: 1.5rem"
          >
            <p-checkbox
              class="v4-color-white"
              name="showResult"
              inputId="showResult"
              [binary]="true"
              [(ngModel)]="survey.showResult"
            ></p-checkbox>
            <label class="v4-color-white" for="showResult">{{
              "Show Option to View Results on Profile Page" | translator
            }}</label>
          </div>
        </div>
    <div class="d-flex flex-row gap-2 w-100 align-items-center justify-content-start">
      <label [htmlFor]="'view-mode'">{{ "Display Mode" | translator }}: </label>
      <p-selectButton id="view-mode" [options]="displayModes" [(ngModel)]="survey.settings.displayMode"
        optionLabel="label" optionValue="value"></p-selectButton>
    </div>
    <!-- <div class="p-fluid w-100 mt-2">
      <label class="mb-1" for="topics">{{
        "Question Topics" | translator
        }}</label>
      <p-chips 
          [(ngModel)]="survey.topics"
          [addOnBlur]="true" 
          [addOnTab]="true" 
          name="topics"
          separator=","
          #topicMailChips
          class="p-chipp">
      </p-chips>
    </div> -->

    <div class="p-fluid w-100 mt-2">
      <h3 class="mb-1">{{
        "Question Topics" | translator
        }}</h3>
      
      <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="selectedNode" (onNodeSelect)="toggleSelection($event)"  emptyMessage="{{'No question classification created' | translator}}"></p-tree>
      
      <div class="mt-3 flex items-center gap-2">
        <input pInputText type="text" [(ngModel)]="newNodeData" placeholder="{{'enter question classification name' | translator }}" class="p-inputtext-sm"/>
        <button pButton label="{{'Add new question topic' | translator }}" icon="pi pi-plus" (click)="addNode()"></button>
      </div>
    </div>


  </ng-template>
  <ng-template pTemplate="footer">
    <p-button (onClick)="openSettingsModal = false; saveProgress(true,false)" [label]="'OK' | translator"
      icon="pi pi-check"></p-button>
  </ng-template>
</p-dialog>

<!-- Reorder Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openReorderModal"
  [style]="{ width: '95vw', maxWidth: '1200px' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "Rearrangement" | translator }}</span>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="w-100">
      <table cdkDropList (cdkDropListDropped)="drop($event)" class="w-100"
        style="border-collapse: separate; border-spacing: 10px">
        <tr class="w-100" style="
            cursor: grab;
            background-color: rgba(255, 255, 255, 0.09);
            padding: 10px 0px;
            border-radius: 4px;
          " cdkDrag *ngFor="let rowData of orderableList; let index = index">
          <td class="text-center">
            <span class="pi pi-bars"></span>
          </td>
          <td class="d-flex flex-row justify-content-between align-items-center w-100">
            <div>
              <span class="mx-2">[{{ rowData.questionCode }}]</span>
              <span>{{
                rowData.questionText || rowData.meta.fields[0].label
                }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-center text-light" style="
                width: 30px;
                height: 30px;
                background-color: rgba(34, 33, 54, 0.5);
              ">
              {{ rowData.index }}
            </div>
          </td>
        </tr>
      </table>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button (onClick)="saveOrder()" label="{{ 'OK' | translator }}" icon="pi pi-check"></p-button>
  </ng-template>
</p-dialog>

<!-- Add Question from Topic Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" [header]="'Add Question from Topic' | translator"
  [(visible)]="openTopicQAddModal" [style]="{ width: '95vw', maxWidth: '1200px' }">
  <ng-template pTemplate="body">
    <div class="w-100">
      <!-- Filter by difficulty level dropdown -->
      <div class="d-flex flex-column align-items-start justify-content-start">
        <label>{{ "Difficulty Level" | translator }}</label>
        <p-dropdown appendTo="body" [options]="difficultyLevels" (onChange)="filterTopicQuestions($event)"></p-dropdown>
      </div>
      <!-- "Select All" Checkbox -->
      <div>
        <input type="checkbox" id="selectAllCheckbox" name="selectAllCheckbox" [(ngModel)]="selectAllQuestions"
          (change)="toggleSelectAll()" class="checkbox" />
        <label for="selectAllCheckbox" class="p-20" style="cursor: pointer">{{
          "Select All" | translator
          }}</label>
      </div>

      <!-- Question List -->
      <div *ngFor="let question of filteredTopicQuestions; let i = index">
        <ng-container *ngIf="isSurvey || !questionsHideAssessment.includes(question.type)">
          <div class="question-container">
            <!-- Individual Question Checkbox -->
            <div class="d-flex align-items-center">
              <div>
                <input type="checkbox" [(ngModel)]="selectedQuestions[question._id]"
                  (click)="SaveQuestionsToAdd(question._id)" class="checkbox" />
              </div>
              <div class="w-100">
                <app-questions-edit [disabled]="true" [editingIndex]="editingIndex"
                  [conditionalQuestions]="conditionalQuestions" [question]="question" [questionIndex]="i"
                  [removeQuestion]="removeQuestion" [disableConditionalOptions]="disableConditionalOptions"
                  [getConditionalOptions]="getConditionalOptions" [isAssessment]="isAssessment" [isTopic]="isTopic"
                  [survey]="survey" [fromTraining]="fromTraining" (saveProgress)="saveProgress()" [isImpactSurvey]="isImpactSurvey"></app-questions-edit>
              </div>
            </div>
            <!-- position under bar with buttons custom code start -->
            <div class="pos-rel">
              <div class="hrr"></div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button (onClick)="confirmAddTopicQuestions()" label="{{ 'OK' | translator }}" icon="pi pi-check"></p-button>
  </ng-template>
</p-dialog>

<!-- Add Question to Topic Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" [header]="'Add Question to Topic and Assessment' | translator"
  [(visible)]="openQAddModal" [style]="{ width: '95vw', maxWidth: '1200px' }">
  <ng-template pTemplate="body">
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    <div class="w-100">
      <div class="w-100">
        <app-questions-edit [disabled]="false" [editingIndex]="-2" [conditionalQuestions]="conditionalQuestions"
          [question]="questionsToTopic" [questionIndex]="-2" [removeQuestion]="null"
          [disableConditionalOptions]="disableConditionalOptions" [getConditionalOptions]="getConditionalOptions"
          [isAssessment]="isAssessment" [isTopic]="isTopic" [survey]="survey" [fromTraining]="fromTraining"
          (saveProgress)="saveProgress()" [isImpactSurvey]="isImpactSurvey"></app-questions-edit>
        <!-- position under bar with buttons custom code start -->
        <div class="pos-rel">
          <div class="hrr"></div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button (onClick)="confirmAddQuestionTopic()" label="{{ 'OK' | translator }}" icon="pi pi-check"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" header="{{ 'Select Service' | translator }}" [maximizable]="true"
  [(visible)]="showSelectServiceModal" [style]="{ width: '95vw', maxWidth: '1700px', maxHeight: '900px' }">
  <div style="
      padding: 15px;
      background-color: rgba(255, 255, 255, 0.09);
      border-radius: 15px;
    ">
    <app-select-service (currentDataItem)="setServiceLink($event)"></app-select-service>
  </div>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" [header]="'Grades Criteria' | translator" [maximizable]="true"
  [(visible)]="openGradesModal" [style]="{ width: '95vw', maxWidth: '1200px' }">
  <div *ngFor="let criteria of survey.percentageCriteria; let i = index">
    <div class="my-3 row">
      <div class="col-md-3 col-12 column">
        <label class="label-txt font-bold p-1 v4-color-white 111">{{
          "Grade Title" | translator
          }}</label>
        <input class="inpt-bg-4-modal-2" placeholder="Title" type="text" [(ngModel)]="criteria.title" pInputText [disabled]="!!criteria.editable ? false : true" />
      </div>
      <div class="col-md-2 col-6 column">
        <label class="label-txt font-bold p-1 v4-color-white 222">{{
          "From" | translator
          }}</label>
        <p-inputNumber class="inpt-bg-4-modal" [(ngModel)]="criteria.from" [disabled]="!!criteria.editable ? false : true" [inputStyle]="{
          'width': '50%',
        }"></p-inputNumber>
      </div>
      <div class="col-md-2 col-6 column">
        <label class="label-txt font-bold p-1 v4-color-white 333">{{
          "To" | translator
          }}</label>
        <p-inputNumber class="inpt-bg-4-modal" [(ngModel)]="criteria.to" [disabled]="!!criteria.editable ? false : true" [inputStyle]="{
          'width': '50%',
        }"></p-inputNumber>
      </div>
      <div class="col-md-5 col-12 column">
        <div class="d-flex align-items-end">
          <div class="column">
            <label class="label-txt font-bold p-1 v4-color-white 444">{{
              "Icon" | translator
              }}</label>
            <p-dropdown class="inpt-bg-4-modal custom-dropdown" appendTo="body" [options]="badgeOptions"
              [(ngModel)]="criteria.icon">
              <ng-template let-option pTemplate="item">
                <div class="badge-item">
                  <img [src]="'../../../assets/bg/certificate/' + option" alt="{{ option }}" style="width: 30px" />
                </div>
              </ng-template>
              <ng-template let-selectedOption pTemplate="selectedItem">
                <div class="badge-item">
                  <img [src]="'../../../assets/bg/certificate/' + selectedOption" alt="{{ selectedOption }}"
                    style="width: 30px" />
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div>
            <p-button class="mb-1" [disabled]="survey.percentageCriteria.length == 1"
              styleClass="input-button p-button-rounded p-button-danger p-button-text"
              (onClick)="removePercentageCriteria(i)" icon="pi pi-trash"></p-button>
          </div>
        </div>
      </div>
    </div>
    <hr />
  </div>
  <p-button class="v4-plus" (onClick)="addNewPercentageCriteria()" icon="pi pi-plus"
    styleClass="p-button-rounded p-button-outlined"></p-button>
  <ng-template pTemplate="footer">
    <p-button class="v4-plus" [label]="'Back' | translator" icon="pi pi-angle-right"
      (onClick)="openGradesModal = false;"></p-button>
    <p-button class="v4-plus" [label]="'Save' | translator" icon="pi pi-check"
      (onClick)="openGradesModal = false; openSettingsModal = false; saveProgress(true,false)"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" [header]="'Certificate Text' | translator" [maximizable]="true"
  [(visible)]="openCertificateTextModal" [style]="{ width: '95vw', maxWidth: '1200px' }">
  <p-tabView class="ui-tabview v4-dsbrd-btns" [activeIndex]="0">
    <p-tabPanel class="v4-dsbrd-btns ui-tabview" header="{{ 'Certificate without Ministry Questions' | translator }}">
      <div class="my-3 d-flex flex-column gap-3 align-items-start">
        <p-dropdown [options]="survey.percentageCriteria" [(ngModel)]="dropGrade" optionLabel="title" appendTo="body"
          (onChange)="onChangeGrade($event)" [placeholder]="'Select Grade' | translator">
        </p-dropdown>

        <label class="label-txt p-1 v4-color-white">{{
          "Certificate Top Text" | translator
          }}</label>
        <textarea *ngIf="!!survey.percentageCriteria" [(ngModel)]="
            survey.percentageCriteria[gradeIndex].certificateText.top
          " [required]="true" id="description" class="w-100" [style.height.px]="180">
        </textarea>

        <label class="label-txt p-1 v4-color-white">{{
          "Certificate Middle Text" | translator
          }}</label>
        <textarea *ngIf="!!survey.percentageCriteria" [(ngModel)]="
            survey.percentageCriteria[gradeIndex].certificateText.middle
          " [required]="true" id="description" class="w-100" [style.height.px]="180">
        </textarea>

        <label class="label-txt p-1 v4-color-white">{{
          "Certificate Bottom Text" | translator
          }}</label>
        <textarea *ngIf="!!survey.percentageCriteria" [(ngModel)]="
            survey.percentageCriteria[gradeIndex].certificateText.bottom
          " [required]="true" id="description" class="w-100" [style.height.px]="180">
        </textarea>
      </div>
    </p-tabPanel>
    <p-tabPanel header="{{ 'Certificate with Ministry Questions' | translator }}" *ngIf="!!survey.certificateMinistry">
      <ng-container *ngFor="let key of getKeys(survey.certificateMinistry)">
        <label class="label-txt p-1 v4-color-white">{{
          "Certificate " + key | translator
          }}</label>
        <textarea [(ngModel)]="survey.certificateMinistry[key]" [required]="true" id="description-{{ key }}"
          class="w-100" [style.height.px]="180">
        </textarea>
      </ng-container>
    </p-tabPanel>
  </p-tabView>

  <ng-template pTemplate="footer">
    <p-button class="v4-plus" [label]="'Back' | translator" icon="pi pi-angle-right"
      (onClick)="openCertificateTextModal = false;"></p-button>
    <p-button class="v4-plus" [label]="'Save' | translator" icon="pi pi-check"
      (onClick)="openCertificateTextModal = false; openSettingsModal = false; saveProgress(true,false)"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" [header]="'Automatic Question Generator' | translator"
  [(visible)]="showAutoQuestionModal" [style]="{ width: '95vw', maxWidth: '1200px' }">
  <ng-template pTemplate="body">
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    <div class="w-100">
      <div class="w-100">
        <div class="d-flex column gap-1 align-items-start justify-content-start mt-2">
          <span class="ans-color">{{ "Select OU" | translator }}</span>
          <input style="
            width: 440px;
            height: 49px;" class="input-number-field" [(ngModel)]="selectedOusLabel" 
            type="text" [readonly]="true"
            (click)="openSelectOUModal = true"
           />
        </div>
        <div class="d-flex column gap-1 align-items-start justify-content-start">
          <span class="ans-color">{{ "Topics" | translator }}</span>
          <div class="pppp-drop">
            <p-multiSelect [options]="filterQuestionBankAll" [placeholder]="'Any Topic' | translator"
              [(ngModel)]="selectedQBs" optionLabel="name" optionValue="_id" 
                appendTo="body" display="chip" 
              >
            </p-multiSelect>
          </div>
        </div>
        <div class="d-flex column gap-1 align-items-start justify-content-start mt-2">
          <span class="ans-color">{{ "Difficulty Level" | translator }}</span>
          <div class="pppp-drop">
            <p-multiSelect [options]="difficultyLevels" [placeholder]="'Any Difficulty Level' | translator"
              [(ngModel)]="selectedLevels" optionLabel="label" optionValue="value" 
              appendTo="body" display="chip">
            </p-multiSelect>
          </div>
        </div>
        <div class="d-flex column gap-1 align-items-start justify-content-start mt-2">
          <span class="ans-color">{{ "Question Type" | translator }}</span>
          <div class="pppp-drop">
            <p-multiSelect [options]="questionTypes" [placeholder]="'Any Question Type' | translator"
              [(ngModel)]="selectedTypes" optionLabel="name" optionValue="type" 
              appendTo="body" display="chip">
            </p-multiSelect>
          </div>
        </div>
        <div class="d-flex column gap-1 align-items-start justify-content-start mt-2">
          <span class="ans-color">{{ "No. of Question" | translator }}</span>
          <p-inputNumber inputId="integeronly" class="input-number-field" [(ngModel)]="questionLimit" [max]="100"
            [inputStyle]="{
              width: '441px',
            }"
           />
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button (onClick)="generateQuestions()" label="{{ 'Generate' | translator }}" icon="pi pi-check"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" [header]="'Select OU' | translator" [maximizable]="true"
  [(visible)]="openSelectOUModal" [style]="{ width: '95vw', maxWidth: '1200px' }">
  <div class="d-flex justify-content-center" *ngIf="selectedOus" style="width: 441px;">
    <p-treeSelect
        [options]="selectedOus" 
        appendTo="body" 
        selectionMode="multiple" 
        [metaKeySelection]="false"  
        class="w-md-20rem w-100 custom-tree"
        containerStyleClass="w-100"  
        (selectionChange)="ouChanged($event)"
        (onNodeSelect)="null"
        filterPlaceholder="{{ 'Search filter' | translator }}"
        [(ngModel)]="selectedTreeData" 
        [filter]="true"
      >
        <ng-template let-node pTemplate="default">
          <div class="d-flex" [ngClass]="
              selectedOus && selectedOus.includes(node) ? 'selectedNode' : ''">
            <img *ngIf="checkisImg(node.data); else elseBlock" 
              src="{{ staticURL }}{{ node.data }}" 
              class="img-fluid p-1 tree-img-bg" 
              style="max-height: 30px; max-width: 30px" />
            <ng-template #elseBlock>
              <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
            </ng-template>
            <b class="text-nowrap">{{ node.label }}</b>
          </div>
        </ng-template>
      </p-treeSelect>
  </div>
  <ng-template pTemplate="footer">
    <p-button class="v4-plus" [label]="'Select' | translator" icon="pi pi-check"
      (onClick)="openSelectOUModal = false;"></p-button>
  </ng-template>
</p-dialog>

<!-- Add Question from Topic Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" [header]="'External User Fields' | translator"
  [(visible)]="openExternalFieldsModal"  [maximizable]="true" [style]="{ width: '95vw'}">
  <ng-template pTemplate="body">
    <app-skelitions [hidden]="!skelition" [value]="1" class="mb-2"></app-skelitions>
    <div class="w-100" *ngIf="!skelition">
      <div class="d-flex justify-content-center mb-3">
          <button class="btn add-question mob-view" (click)="openSidebar(-1)">
            {{ "Add a question" | translator }}
          </button>
        </div>
        <!-- Second i should be replaced with editingIndex after implementing recognizing mechonizam -->
        <div *ngFor="let question of survey.externalQuestions; let i = index">
          <div>
            <app-questions-edit (click)="setCurrentEditQuestion(i)"
              [editingIndex]="editingIndex" [question]="question" [questionIndex]="i" [removeQuestion]="removeQuestion"
              [isAssessment]="isAssessment" [isTopic]="isTopic" [survey]="survey" [fromTraining]="fromTraining"
              (saveProgress)="saveProgress()" [UserExternalFields]="true" ></app-questions-edit>
            <!-- position under bar with buttons custom code start -->
            <div class="pos-rel">
              <div class="flex-center my-3">
                <button class="btn add-question" (click)="openSidebar(i)">
                  {{ "Add a question" | translator }}
                </button>
              </div>
            </div>
          </div>
        </div>   
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button class="v4-plus" [label]="'Back' | translator" icon="pi pi-angle-right"
      (onClick)="openExternalFieldsModal = false;"></p-button>
    <p-button (onClick)="saveProgress(true,false)" label="{{ 'save' | translator }}" icon="pi pi-check"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" header="{{'Set Reminder' | translator}}" [maximizable]="true"
  [(visible)]="showReminderModal" [style]="{ width: '95vw', maxWidth: '1700px', maxHeight: '900px' }">
  <div style=" padding: 15px; background-color: rgba(255, 255, 255, 0.09); border-radius: 15px;">
   <app-reminder-modal *ngIf="showReminderModal" (close)="showReminderModal = false" [_id]="survey._id" [startDate]="survey.startDate" [type]="isAssessment ? 'ASSESSMENT' : 'SURVEY'"></app-reminder-modal>
  </div>
</p-dialog>

<app-footer></app-footer>